export const SEND_PHONE = 'AUTH_STEP__SEND_PHONE'
export const SEND_CODE = 'AUTH_STEP__SEND_CODE'
